import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthorizatedGuard } from './guards/authorizated.guard';
import { NoIfAuthorizatedGuard } from './guards/noifauthorizated.guard';
import { AuthService } from './services/acceso/auth.service';
import { Configuration } from './configuration/configuration';
import { CustomInterceptor } from './interceptors/CustomInterceptor';
import { SessionHelper } from './helper/sessionHelper';
import { LivesSessionHelper } from './helper/livesSessionHelper';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    AuthorizatedGuard,
    NoIfAuthorizatedGuard,
    Configuration,
    AuthService,
    SessionHelper,
    LivesSessionHelper,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomInterceptor,
      multi: true
    }
  ],
  bootstrap: []
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
